module.exports = __webpack_public_path__ + "static/media/cl.2fd895c4.svg";